// extracted by css-extract-rspack-plugin
export default {"root":"W0oG07gzDUIJVbRD","header":"s0Dmzd6Y1c8XH0an","item":"VdwJqQeHTEzQ1nTP","list":"rtVMs014IPg2pfrL","disclaimer":"zaqWEvohY8oTcNH6"};